// settings for recruit info page tabs

const recruitInfoTabs = () => {
  const tabTriggers = document.querySelectorAll('.js-flow-tab');
  const tabContents = document.querySelectorAll('.js-tab-content');

  if (!tabTriggers.length || !tabContents.length) return;

  tabTriggers.forEach((tabTrigger, index) => {
    tabTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      tabContents.forEach((tabContent) => {
        tabContent.classList.remove('active');
      });
      tabContents[index].classList.add('active');
    });
  });
};

export default recruitInfoTabs;
